export default function TestApiConfiguration($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('test.api');
}

TestApiConfiguration.$inject = ['$translatePartialLoaderProvider'];
